import { defineComponent } from 'vue'

// Utils
import { getSizeStyle, makeStringProp, numericProp } from '@xzx-design/utils'
import { useNamespace } from '@xzx-design/hooks'
import type { ExtractPropTypes } from 'vue'

export type SkeletonAvatarShape = 'square' | 'round'

export const skeletonAvatarProps = {
  avatarSize: numericProp,
  avatarShape: makeStringProp<SkeletonAvatarShape>('round'),
}

export type SkeletonAvatarProps = ExtractPropTypes<typeof skeletonAvatarProps>

const name = 'XzxSkeletonAvatar'

export default defineComponent({
  name,
  __name: name,
  props: skeletonAvatarProps,
  setup(props) {
    const { bem } = useNamespace('skeleton-avatar')

    return () => (
      <div
        class={bem([props.avatarShape])}
        style={getSizeStyle(props.avatarSize)}
      />
    )
  },
})
